import axios from 'axios'
import { clearUserData } from '@/shared'
import Cookies from 'js-cookie'
import { axiosIDBCache } from '@/utils/axiosIDBCache'

const getAdditionalHeaders = () => {
	const langs = {
		rus: 'ru',
		kz: 'kz',
	}

	let lang = 'ru'
	let activeRole = ''
	try {
		activeRole = JSON.parse(localStorage.getItem('activeRole')) || ''
		lang = localStorage.getItem('lang')
	} catch (error) {}
	return { 'Accept-Language': langs[lang], role: activeRole }
}

const instance = axios.create({
	baseURL: process.env.REACT_APP_API_URL,
	withCredentials: true,
	crossOriginIsolated: false,
	headers: getAdditionalHeaders(),
});

instance.interceptors.request.use(
	(config) => {
		const additionalHeaders = getAdditionalHeaders()
		return { ...config, headers: { ...config.headers, ...additionalHeaders } }
	},
	(error) => Promise.reject(error)
)

instance.interceptors.response.use(
	(response) => response,
	(error) => {
		if (401 === error.response?.status || 403 === error.response?.status) {
			clearUserData();
			Cookies.remove('hr_logged');
			Cookies.remove('UserInfo');
			if (window.location.pathname !== '/') {
				window.location.href = process.env.REACT_APP_LOGOUT_REDIRECT;
			}
			return;
		}
		return Promise.reject(error);
	}
);

const cache = axiosIDBCache(instance)

export async function request(config) {
	return cache.request(config)
}

export const cacheClearAll = () => cache.cacheClearAll()
export const setupCacheAutoClearOnReload = () => cache.setupCacheAutoClearOnReload()